module.exports = __webpack_public_path__ + "img/terroir-spiral-2.8cb5ee94.jpg";